/**
 * Copyright 2025 John Huikku Alienrobot LLC
 * www.ALIENROBOT.com
 */

import { useState } from 'react'

interface UseInflationReturn {
  inflatedMarkdown: string
  isInflating: boolean
  selectedInflatedDoc: string | null
  inflatedDocs: Record<string, string>
  copiedInflate: boolean
  copiedPreview: boolean
  hasInflatedCurrentThread: boolean
  setInflatedMarkdown: (markdown: string) => void
  setIsInflating: (inflating: boolean) => void
  setSelectedInflatedDoc: (docId: string | null) => void
  setInflatedDocs: React.Dispatch<React.SetStateAction<Record<string, string>>>
  setCopiedInflate: (copied: boolean) => void
  setCopiedPreview: (copied: boolean) => void
  setHasInflatedCurrentThread: (hasInflated: boolean) => void
}

export function useInflation(): UseInflationReturn {
  const [inflatedMarkdown, setInflatedMarkdown] = useState('')
  const [isInflating, setIsInflating] = useState(false)
  const [selectedInflatedDoc, setSelectedInflatedDoc] = useState<string | null>(null)
  const [inflatedDocs, setInflatedDocs] = useState<Record<string, string>>({})
  const [copiedInflate, setCopiedInflate] = useState(false)
  const [copiedPreview, setCopiedPreview] = useState(false)
  const [hasInflatedCurrentThread, setHasInflatedCurrentThread] = useState(false)

  return {
    inflatedMarkdown,
    isInflating,
    selectedInflatedDoc,
    inflatedDocs,
    copiedInflate,
    copiedPreview,
    hasInflatedCurrentThread,
    setInflatedMarkdown,
    setIsInflating,
    setSelectedInflatedDoc,
    setInflatedDocs,
    setCopiedInflate,
    setCopiedPreview,
    setHasInflatedCurrentThread,
  }
}

